import { Image, Pressable } from '@gluestack-ui/themed';
import { useNavigation } from '@react-navigation/native';
import type { FC } from 'react';
import Bioeureka from '../../assets/bioeureka.svg';
import { Routes } from '../../routes/Routes';

export const HeaderLeft: FC = () => {
  const navigation = useNavigation<any>();
  return (
    <Pressable
      onPress={() => navigation.navigate(Routes.ANALYSIS_LIST, { refresh: true })}
      accessibilityLabel="Accueil"
    >
      <Image alt="Bioeureka logo" source={Bioeureka} style={{ height: 34, width: 247 }} />
    </Pressable>
  );
};
